module.exports = __webpack_public_path__ + "img/service-nongmaojianguan3.878fd4bd.svg";